import React from 'react';

function Variability({ varianceScore }) {
  switch (true) {
    case varianceScore > 1:
      return <h5 className="high-variance">High</h5>;

    case varianceScore > 0.2:
      return <h5 className="medium-variance">Medium</h5>;

    case varianceScore === null:
      return <h5 className="text-muted">N/A</h5>;

    default:
      return <h5 className="low-variance">Low</h5>;
  }
}

export default Variability;
